import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {SearchResultsCareproviderUnitItem} from '../../../../../../types/SearchResultsCareproviderUnitItem';
import {SearchState} from '../../../../../../types/SearchState';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {CpruTabsService} from '../../../../../../services/cpru-tabs.service';
import {SerpItemComponentEnum} from '../../enums/serp-item-component.enum';
import {RoutesAddonsEnums} from '../../../../../../enums/RoutesEnums';

@Component({
  selector: 'app-search-results-list-v5',
  templateUrl: './search-results-list-v5.component.html',
  styleUrls: ['./search-results-list-v5.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsListV5Component {
  public cpruTabsService = inject(CpruTabsService);
  public highlightedSection = this.cpruTabsService.highlightedSection;
  results = input<SearchResultsCareproviderUnitItem[]>();
  searchState = input<SearchState>();
  bannerPlacingIndex = computed<number>(() =>
    Math.min(4, this.results() && this.results().length > 0 ? this.results().length - 1 : 0),
  );
  serpComponent = computed<SerpItemComponentEnum>(() =>
    this.highlightedSection() === RoutesAddonsEnums.SERP_SERVICES
      ? SerpItemComponentEnum.CARESERVICE
      : SerpItemComponentEnum.CAREPROVIDER_WITH_SERVICES,
  );
  public pageType: DLPageTypeEnum = DLPageTypeEnum.SEARCH_PAGE;
  protected readonly SerpItemComponentEnum = SerpItemComponentEnum;
}
